// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"d511b026","774":"139d8656"}[chunkId] + ".css";
};